import React, { Component } from 'react';
import Modal from 'react-modal';
import Col from 'react-bootstrap/Col';
import { Image, Collapse } from 'react-bootstrap';
//import HamburgurIconMenu from "./HamburgurIconMenu";
//import { IconButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NavLink, withRouter } from 'react-router-dom';
import AddDinerPopup from '../../reusableComponents/allPopupReusable/addDinerAndAddReservation/AddDinerPopup';
import OfferPopup from '../../reusableComponents/allPopupReusable/offerEventPopup/OfferPopup';
import EventPopup from '../../reusableComponents/allPopupReusable/offerEventPopup/EventPopup';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import AddVendorSuggestionIssuesPopup from '../vendorOpenIssuesSuggestions/AddIssuesPopup/AddVendorSuggestionIssuesPopup';
import AddUserTicketIssuesPopup from '../openIssuesVendor/AddUserTicketIssues/AddUserTicketIssuesPopup';
import { ReusableMenuLink, ReusableMenuLinkCollapse } from './ReusableMenuLink';
import { QRCode } from 'react-qr-svg';
import { ReusableOnboardingButton } from '../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import SVG from 'react-inlinesvg';
import Scrollbars from 'react-custom-scrollbars';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import {
  GET_VENDOR_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
} from '../../../store/types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import isEmpty from '../../../store/validation/is-Empty';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { withRouter } from "react-router-dom";
import { clear_all_errors } from '../../../store/actions/errorActions';
import { logOutUser } from '../../../store/actions/authAction';
import Media from 'react-media';
import AddOpenIssuesVendor from '../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/InsideAllPageComponent/AddOpenIssuesVendor';
import AddDinerNewRedirect from '../seatingDashboard/AddDinerNewRedirect';
import { version } from '../../../config/Keys';
import LOGO_MAIN from '../../../assets/images/Login/logo.png';
import QRCodeMerchants from '../../reusableComponents/QRCodePrintAndExport/QRCodeMerchants';
import { webappUrl } from '../../../config/Keys';
import ShareLinkModal from '../../reusableComponents/ShareLinkModal';
// var QRCodeNew = require("qrcode.react");

// function history1(props){
//   const history = useHistory();
//   const dispatch = useDispatch();
// }
// const history = useHistory();
// const dispatch = useDispatch();
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
  },
};

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export class RightSideNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onBoardingDataId: '',
      profileCompleted: '',
      restaurantName: '',
      restaurantLogo: '',
      point_of_contact: {},
      shareLink: {},
      hasSetMapProps: false,
      openQrCode: false,
      openNavbar: false,
      openRestaurantDetailsMenu: false,
      openHealthAndSanitization: false,
      openFoodCategories: false,
      openBankDetails: false,
      openSubscriptions: false,
      openOtherSettings: false,

      offerManagmentDisplay: false,
      scanAndPayDisplay: false,
      eventManagmentDisplay: false,
      experienceManagmentDisplay: false,
      liveStreamingDisplay: false,
      seatingManagementDisplay: false,
      orderingManagementDisplay: false,
      menuSetupDisplay: false,

      // casualDiningActiveService: false,
      // fastFoodActiveService: false,
      // multiActiveService: false,
    };
  }

  // addNewItem(){
  //   dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: "" });
  //   dispatch({ type: GET_VENDOR_MENU_CATEGORY_ITEMS, payload: [] });
  //   history.push("/additemavailablity");
  // };

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.onboarding && !isEmpty(nextProps.onboarding._id)) {
      return {
        onBoardingDataId: !isEmpty(nextProps.onboarding._id)
          ? nextProps.onboarding._id
          : '',
        profileCompleted: !isEmpty(nextProps.onboarding.page_completed_till)
          ? nextProps.onboarding.page_completed_till
          : '',
        restaurantName: !isEmpty(nextProps.onboarding.restaurant_name)
          ? nextProps.onboarding.restaurant_name
          : '',
        restaurantLogo: !isEmpty(nextProps.onboarding.logo_url)
          ? nextProps.onboarding.logo_url
          : '',
        point_of_contact: !isEmpty(nextProps.onboarding.point_of_contact[0])
          ? nextProps.onboarding.point_of_contact[0]
          : {},
        shareLink: !isEmpty(nextProps.onboarding.shareLink)
          ? nextProps.onboarding.shareLink
          : {},

        /*************************************
         * @DESC Active Service
         **************************************/
        // casualDiningActiveService: nextProps?.casualDiningService
        //   ? true
        //   : false,
        // fastFoodActiveService: nextProps?.fastFoodDiningService ? true : false,
        // multiActiveService: nextProps?.multiDiningService ? true : false,

        /*************************************
         * @DESC Offer Management
         **************************************/
        offerManagmentDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.offer_management?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.offer_management?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.offer_management?.value)
            ? true
            : false,
        /*************************************
         * @DESC Scan And Pay Management
         **************************************/
        scanAndPayDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.scan_and_pay?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.scan_and_pay?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.scan_and_pay?.value)
            ? true
            : false,

        /*************************************
         * @DESC Event Management
         **************************************/
        eventManagmentDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.event_management?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.event_management?.value)
            ? true
            : false,

        /*************************************
         * @DESC Experience Management
         **************************************/
        experienceManagmentDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.experience_management?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.experience_management?.value)
            ? true
            : false,

        /*************************************
         * @DESC live Streaming Management
         **************************************/
        liveStreamingDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.live_streaming?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.live_streaming?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.live_streaming?.value)
            ? true
            : false,

        /*************************************
         * @DESC Seating Management
         **************************************/
        seatingManagementDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.seating?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.seating?.value)
            ? true
            : false,

        /*************************************
         * @DESC Ordering Management
         **************************************/
        orderingManagementDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.ordering?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.ordering?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.ordering?.value)
            ? true
            : false,

        /*************************************
         * @DESC Menu Setup Management
         **************************************/
        menuSetupDisplay:
          (nextProps?.casualDiningService &&
            nextProps?.casualDiningData?.menu_setup?.value) ||
          (nextProps?.fastFoodDiningService &&
            nextProps?.fastFoodDiningData?.menu_setup?.value) ||
          (nextProps?.multiDiningService &&
            nextProps?.multiDiningData?.menu_setup?.value)
            ? true
            : false,

        hasSetBankProps: true,
      };
    }
    return null;
  }

  onOpenModal = (e) => {
    this.closeNav();
    this.setState({
      openQrCode: true,
    });
  };

  onCloseModal = (e) => {
    this.setState({
      openQrCode: false,
    });
  };

  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logOutUser();
  };

  openNav = () => {
    document.getElementById('mySidenav').style.right = '0'; //329px
  };

  closeNav = () => {
    document.getElementById('mySidenav').style.right = '-340px';
  };

  openRestaurantDetailsMenu = (e) => {
    this.setState({
      openRestaurantDetailsMenu: !this.state.openRestaurantDetailsMenu,
    });
  };

  openHealthAndSanitization = (e) => {
    this.setState({
      openHealthAndSanitization: !this.state.openHealthAndSanitization,
    });
  };

  openFoodCategories = (e) => {
    this.setState({
      openFoodCategories: !this.state.openFoodCategories,
    });
  };

  openBankDetails = (e) => {
    this.setState({
      openBankDetails: !this.state.openBankDetails,
    });
  };

  openSubscriptions = (e) => {
    this.setState({
      openSubscriptions: !this.state.openSubscriptions,
    });
  };

  openOtherSettings = (e) => {
    this.setState({
      openOtherSettings: !this.state.openOtherSettings,
    });
  };

  printQrCodeAction = () => {
    const printableElements = document.getElementById('printme').innerHTML;
    const orderHtml =
      '<html><head><title></title></head><body>' +
      printableElements +
      '</body></html>';
    const oldPage = document.body.innerHTML;
    document.body.innerHTML = orderHtml;
    window.print();
    // window.location.reload();
    document.body.innerHTML = oldPage;
  };

  downloadQRCode = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'QR_Code.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  addGuestClickHandler = (id) => (e) => {
    this.props.history.push({
      pathname: `/offline-events/add-guest-event/${id}`,
      state: { addGuestInfo: id },
    });
  };

  render() {
    try {
      const {
        profileCompleted,
        offerManagmentDisplay,
        scanAndPayDisplay,
        eventManagmentDisplay,
        experienceManagmentDisplay,
        liveStreamingDisplay,
        seatingManagementDisplay,
        orderingManagementDisplay,
        menuSetupDisplay,
      } = this.state;

      const referrallink =
        this.props.auth?.user?.VendorUser?.shareLink?.userShortLink;
      const devided = profileCompleted && profileCompleted / 21;
      const finalValue = devided * 100;
      const percentage = Math.round(finalValue);
      return (
        <React.Fragment>
          <div
            className="right-side-navigation"
            style={{
              backgroundColor: `${this.props.overlayData ? '' : '#ffffff'}`,
            }}
          >
            <Col
              xs={10}
              md={6}
              className="p-0"
              style={this.props.style && this.props.style}
            >
              <div className="d-flex justify-content-start ">
                {this.props?.noHamburgerMenu && (
                  <img
                    src={LOGO_MAIN}
                    className="img-fluid profile-image-menu p-1"
                    style={{ width: '20vh' }}
                    alt="Amealio Logo"
                    title="Amealio Logo"
                  />
                )}
                <Media query="(min-width:992px)">
                  {this.props.leftText === 'vendorReview' ? (
                    <div className="d-flex align-items-center">
                      {this.props.actionPerform === 'button' ? (
                        <div
                          className="d-flex text-dark text-decoration-none"
                          style={{ cursor: 'pointer' }}
                          onClick={this.props.backButtonLink}
                        >
                          <i
                            className="fa fa-long-arrow-left mr-3"
                            aria-hidden="true"
                          ></i>
                          <h5 className="f12-500">{this.props.displayText}</h5>
                        </div>
                      ) : (
                        <NavLink
                          to={this.props.backButtonLink}
                          className="d-flex text-dark text-decoration-none"
                          style={{ cursor: 'pointer' }}
                        >
                          <i
                            className="fa fa-long-arrow-left mr-3"
                            aria-hidden="true"
                          ></i>
                          <h5 className="f12-500">{this.props.displayText}</h5>
                        </NavLink>
                      )}
                    </div>
                  ) : null}
                </Media>

                <Media query="(max-width:991px)">
                  {this.props.leftText === 'vendorReview' ? (
                    <div className="d-flex align-items-center">
                      {this.props.actionPerform === 'button' ? (
                        <div
                          className="d-flex text-dark text-decoration-none"
                          style={{ cursor: 'pointer' }}
                          onClick={this.props.backButtonLink}
                        >
                          <i
                            className="fa fa-long-arrow-left mr-3"
                            aria-hidden="true"
                          ></i>
                          <h5 className="f12-500">{this.props.displayText}</h5>
                        </div>
                      ) : (
                        <NavLink
                          to={this.props.backButtonLink}
                          className="d-flex text-dark text-decoration-none"
                          style={{ cursor: 'pointer' }}
                        >
                          <i
                            className="fa fa-long-arrow-left mr-3"
                            aria-hidden="true"
                          ></i>
                          {/* <h5 className="f12-500">{this.props.displayText}</h5> */}
                        </NavLink>
                      )}
                    </div>
                  ) : null}
                </Media>
                {!this.props.noEnAdminPic && !this.props?.noHamburgerMenu && (
                  <Media query="(max-width: 991px)">
                    {!this.props?.noHamburgerMenu && (
                      <>
                        <div className="d-flex align-items-center justify-content-center">
                          <div
                            className="enAdminPic rounded d-flex"
                            style={{
                              opacity: `${
                                this.props.overlayData ? '0.2' : '1'
                              }`,
                            }}
                          >
                            <SimpleReactLightbox>
                              <SRLWrapper options={options}>
                                {this.state.restaurantLogo === '' ? null : (
                                  <div
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                    }}
                                  >
                                    <Image
                                      src={
                                        this.state.restaurantLogo &&
                                        this.state.restaurantLogo
                                      }
                                      style={{ borderRadius: '50%' }}
                                      alt="Restaurant Picture"
                                      title="Restaurant Picture"
                                    />
                                  </div>
                                )}
                              </SRLWrapper>
                            </SimpleReactLightbox>
                          </div>
                          <div className="f14-500 ml-2">
                            {this.state.restaurantName === undefined
                              ? null
                              : this.state.restaurantName &&
                                this.state.restaurantName}
                          </div>
                        </div>
                        <div
                          className={`d-flex align-items-center justify-content-end ml-3 ${
                            this.props.overlayData ? '' : 'border-left'
                          } pl-3`}
                        >
                          <div
                            className="enAdminPic rounded d-flex"
                            style={{
                              opacity: `${
                                this.props.overlayData ? '0.2' : '1'
                              }`,
                            }}
                          >
                            {this.state?.point_of_contact?.profile_Photo ===
                              '' ||
                            this.state?.point_of_contact?.profile_Photo ===
                              undefined ||
                            this.state?.point_of_contact?.profile_Photo ===
                              null ? (
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  backgroundColor: '#EE3A23',
                                  borderRadius: '50%',
                                }}
                              >
                                <p className="f18-700 text-white text-uppercase">
                                  {this.state?.point_of_contact === undefined
                                    ? null
                                    : this.state?.point_of_contact?.firstName &&
                                      this.state?.point_of_contact?.firstName.charAt(
                                        0
                                      )}{' '}
                                  {this.state?.point_of_contact === undefined
                                    ? null
                                    : this.state?.point_of_contact?.lastName &&
                                      this.state?.point_of_contact?.lastName.charAt(
                                        0
                                      )}
                                </p>
                              </div>
                            ) : (
                              <SimpleReactLightbox>
                                <SRLWrapper options={options}>
                                  {this.state?.point_of_contact &&
                                  this.state?.point_of_contact
                                    ?.profile_Photo === undefined ? null : (
                                    <div
                                      style={{
                                        width: 'auto',
                                        height: 'auto',
                                      }}
                                    >
                                      <Image
                                        src={
                                          (this.state.point_of_contact &&
                                            this.state.point_of_contact
                                              .profile_Photo !== undefined) ||
                                          this.state.point_of_contact
                                            .profile_Photo !== null ||
                                          this.state.point_of_contact
                                            .profile_Photo !== ''
                                            ? this.state?.point_of_contact
                                                ?.profile_Photo
                                            : require('../../../assets/images/ActionImages/demoprofile.jpg')
                                        }
                                        style={{ borderRadius: '50px' }}
                                        alt="Profile Picture"
                                        title="Profile Picture"
                                      />
                                    </div>
                                  )}
                                </SRLWrapper>
                              </SimpleReactLightbox>
                            )}
                          </div>
                          <div className="f14-500 ml-2 mr-2">
                            {this.state.point_of_contact === undefined
                              ? null
                              : this.state.point_of_contact &&
                                this.state.point_of_contact.firstName}{' '}
                            {this.state.point_of_contact === undefined
                              ? null
                              : this.state.point_of_contact &&
                                this.state.point_of_contact.lastName}
                          </div>
                        </div>
                      </>
                    )}
                  </Media>
                )}

                {this.props.leftText === 'offer' ? (
                  <div className="d-flex align-items-center">
                    <NavLink
                      to={this.props.link}
                      className="d-flex text-dark text-decoration-none"
                      style={{ cursor: 'pointer' }}
                    >
                      <i
                        className="fa fa-long-arrow-left mr-3"
                        aria-hidden="true"
                      ></i>
                      <h5 className="f12-500">{this.props.displayText}</h5>
                    </NavLink>
                  </div>
                ) : null}
                {this.props.leftText === 'history' ? (
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex text-dark text-decoration-none"
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.props.history.goBack()}
                    >
                      <i
                        className="fa fa-long-arrow-left mr-3"
                        aria-hidden="true"
                      ></i>
                      <h5 className="f12-500">{this.props.displayText}</h5>
                    </div>
                  </div>
                ) : null}
                {this.props?.vendorAccess?.vendor_id && (
                  <div className="d-flex align-items-center">
                    <h5
                      className="f12-500"
                      onClick={() => {
                        if (this.props?.vendorAccess?.redirect_back_url) {
                          this.props.history.push(
                            this.props?.vendorAccess?.redirect_back_url
                              ? this.props?.vendorAccess?.redirect_back_url
                              : '/superadmindashboard'
                          );
                        } else {
                          this.props.history.push('/superadmindashboard');
                        }
                      }}
                    >
                      Back to Super Admin
                    </h5>
                  </div>
                )}
                {this.props?.pageTitle ? (
                  <div className="ml-4">
                    <p className="f14-700">{this.props?.pageTitle}</p>
                    {this.props?.pageDesc ? (
                      <p style={{ color: '#666', fontSize: '8px' }}>
                        {this.props?.pageDesc}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </Col>

            <Media query="(max-width: 991px)">
              {this.props?.titleCenter && (
                <Col xs={6} className="text-center f12-500">
                  {this.props?.titleCenter}
                </Col>
              )}
            </Media>
            <Col
              xs={this.props?.titleCenter ? 2 : 2}
              md={6}
              className="p-0 d-flex justify-content-end align-items-center "
            >
              <Media query="(min-width: 992px)">
                {!this.props?.noHamburgerMenu && (
                  <>
                    <div className="d-flex align-items-center justify-content-end">
                      <div
                        className="enAdminPic rounded d-flex"
                        style={{
                          opacity: `${this.props.overlayData ? '0.2' : '1'}`,
                        }}
                      >
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            {this.state.restaurantLogo === '' ? null : (
                              <div
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                              >
                                <Image
                                  src={
                                    this.state.restaurantLogo &&
                                    this.state.restaurantLogo
                                  }
                                  style={{ borderRadius: '50%' }}
                                  alt="Restaurant Picture"
                                  title="Restaurant Picture"
                                />
                              </div>
                            )}
                          </SRLWrapper>
                        </SimpleReactLightbox>
                      </div>
                      <div className="f14-500 ml-2">
                        {this.state.restaurantName === undefined
                          ? null
                          : this.state.restaurantName &&
                            this.state.restaurantName}
                      </div>
                    </div>
                    <div
                      className={`d-flex align-items-center justify-content-end ml-3 ${
                        this.props.overlayData ? '' : 'border-left'
                      } pl-3`}
                    >
                      <div
                        className="enAdminPic rounded d-flex"
                        style={{
                          opacity: `${this.props.overlayData ? '0.2' : '1'}`,
                        }}
                      >
                        {this.state?.point_of_contact?.profile_Photo === '' ||
                        this.state?.point_of_contact?.profile_Photo ===
                          undefined ||
                        this.state?.point_of_contact?.profile_Photo === null ? (
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              width: '100%',
                              height: '100%',
                              backgroundColor: '#EE3A23',
                              borderRadius: '50%',
                            }}
                          >
                            <p className="f18-700 text-white text-uppercase">
                              {this.state?.point_of_contact === undefined
                                ? null
                                : this.state?.point_of_contact?.firstName &&
                                  this.state?.point_of_contact?.firstName.charAt(
                                    0
                                  )}{' '}
                              {this.state?.point_of_contact === undefined
                                ? null
                                : this.state?.point_of_contact?.lastName &&
                                  this.state?.point_of_contact?.lastName.charAt(
                                    0
                                  )}
                            </p>
                          </div>
                        ) : (
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              {this.state?.point_of_contact &&
                              this.state?.point_of_contact?.profile_Photo ===
                                undefined ? null : (
                                <div
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                  }}
                                >
                                  <Image
                                    src={
                                      (this.state.point_of_contact &&
                                        this.state.point_of_contact
                                          .profile_Photo !== undefined) ||
                                      this.state.point_of_contact
                                        .profile_Photo !== null ||
                                      this.state.point_of_contact
                                        .profile_Photo !== ''
                                        ? this.state?.point_of_contact
                                            ?.profile_Photo
                                        : require('../../../assets/images/ActionImages/demoprofile.jpg')
                                    }
                                    style={{ borderRadius: '50%' }}
                                    alt="Profile Picture"
                                    title="Profile Picture"
                                  />
                                </div>
                              )}
                            </SRLWrapper>
                          </SimpleReactLightbox>
                        )}
                      </div>
                      <div className="f14-500 ml-2 mr-2 d-flex">
                        {this.state.point_of_contact === undefined
                          ? null
                          : this.state.point_of_contact &&
                            this.state.point_of_contact.firstName}{' '}
                        {this.state.point_of_contact === undefined
                          ? null
                          : this.state.point_of_contact &&
                            this.state.point_of_contact.lastName}
                      </div>
                    </div>
                  </>
                )}
              </Media>

              <Media query="(max-width: 991px)">
                {this.props.displayButton === 'addDiner' ? (
                  <AddDinerNewRedirect />
                ) : null || this.props.displayButton === 'addOffer' ? (
                  <OfferPopup bigText="Add New Offer" />
                ) : null || this.props.displayButton === 'addguest' ? (
                  <button
                    className="btn btn-danger btn2 btn-sm"
                    onClick={this.addGuestClickHandler(
                      this.props.getSingleEventInfo._id
                    )}
                  >
                    + Add Guest
                  </button>
                ) : null || this.props.displayButton === 'addEvent' ? (
                  <NavLink
                    to="/event/add-event"
                    className="btn btn-danger btn2 btn-sm"
                  >
                    + Add Event
                  </NavLink>
                ) : null ||
                  this.props.displayButton === 'addOpenIssuesUsers' ? (
                  <AddOpenIssuesVendor />
                ) : null ||
                  this.props.displayButton ===
                    'addOpenIssuesVendorSuggestion' ? (
                  <AddVendorSuggestionIssuesPopup
                    bigText="Add Issue"
                    newButton={
                      this.props.newButton ? this.props.newButton : false
                    }
                  />
                ) : null || this.props.displayButton === 'addRoleManagement' ? (
                  <Media query="(max-width: 992px)">
                    <NavLink
                      to="/addrole"
                      className="btn btn-danger text-normal btn-xs rounded"
                    >
                      + Add Role
                    </NavLink>
                  </Media>
                ) : null ||
                  this.props.displayButton === 'buttonDisplayByChild' ? (
                  <Media query="(max-width: 992px)">
                    {this.props.buttonDisplayByChild}
                  </Media>
                ) : null || this.props.displayButton === 'itemAvailability' ? (
                  <Media query="(max-width: 992px)">
                    {this.props.ItemAvailabilityButton}
                  </Media>
                ) : null || this.props.displayButton === 'refferal' ? (
                  <Media query="(max-width: 992px)">
                    {this.props.RefferalButton}
                  </Media>
                ) : null || this.props.displayButton === 'StaffManagement' ? (
                  <Media query="(max-width: 992px)">
                    {this.props.StaffManagementButton}
                  </Media>
                ) : null || this.props.displayButton === 'itemAvailability' ? (
                  <Media query="(max-width: 992px)">
                    {this.props.ItemAvailabilityButton}
                  </Media>
                ) : null}
              </Media>
              {!this.props?.noHamburgerMenu && (
                <i
                  className="fa fa-bars hamburgur-class cursor"
                  style={{
                    color: `${this.props.overlayData ? '#000000' : '#f85032'}`,
                  }}
                  aria-hidden="true"
                  onClick={this.openNav}
                ></i>
              )}
              <div id="mySidenav" className="sidenav">
                <div className="profile-and-close-css">
                  <div className="w-100 d-flex align-items-center">
                    <SimpleReactLightbox>
                      <SRLWrapper options={options}>
                        <Image
                          src={this.state.restaurantLogo}
                          className="img-fluid profile-image-menu p-1"
                          alt="Restaurant Picture"
                          title="Restaurant Picture"
                        />
                      </SRLWrapper>
                    </SimpleReactLightbox>
                    <div>
                      <p>{this.state.restaurantName}</p>
                    </div>
                  </div>
                  <div
                    style={{ width: 120 }}
                    className="d-flex align-items-center flex-column"
                  >
                    <div style={{ width: 40 }}>
                      <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        styles={buildStyles({
                          pathColor: `#212121`,
                          textColor: '#212121',
                          trailColor: '#C7C7C7',
                          backgroundColor: '#3e98c7',
                        })}
                      />
                    </div>
                    <div className="fixf10-400 mt-2">Profile Completion</div>
                  </div>
                  <SVG
                    src={require('../../../assets/images/UserManagement/close.svg')}
                    alt="Close"
                    className="cursor hamburgur-class"
                    onClick={this.closeNav}
                  />
                </div>
                <hr />
                <Scrollbars
                  style={{ width: '100%', height: 'calc(100vh - 126px)' }}
                >
                  <ReusableMenuLink
                    onClick={() => this.props.history.push('/editprofile')}
                    srcImage={require('../../../assets/images/RightNavigationIcon/user.svg')}
                    headingText="Profile"
                    styleClass={
                      this.props.history?.location?.pathname === '/editprofile'
                        ? 'border border-dark'
                        : ''
                    }
                  />
                  <ReusableMenuLink
                    onClick={() => this.props.history.push('/editmapsetup')}
                    srcImage={require('../../../assets/images/RightNavigationIcon/map.svg')}
                    headingText="Map Setup"
                    styleClass={
                      this.props.history?.location?.pathname === '/editmapsetup'
                        ? 'border border-dark'
                        : ''
                    }
                  />
                  <ReusableMenuLinkCollapse
                    onClick={this.openRestaurantDetailsMenu}
                    state={this.state.openRestaurantDetailsMenu}
                    srcImage={require('../../../assets/images/RightNavigationIcon/restaurant.svg')}
                    headingText="Business Details"
                  />
                  <Collapse in={this.state.openRestaurantDetailsMenu}>
                    <div id="example-collapse-text">
                      <div className="example-collapse-text-inside">
                        <NavLink
                          exact
                          to="/editrestaurantdetails"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/refresh.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Update Business Details</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editpointofcontacts"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/telephone.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Point Of Contact</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editrestaurantimage"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/refresh.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Update Business Logo & Images</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editrestaurantchains"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/link.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Business Settings</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editrestauranttype"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/tray.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Business Type</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editpaymentmethod"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/pay.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Payment Methods</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editdresscode"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/bow.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Dress Code</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editpetsallowed"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/dog.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Pets Allowed</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editlocatedinside"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/location.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Located Inside</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editparking"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/parking.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Parking</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editaccessibility"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/wheelchair.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Accessibility</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editotherfeatures"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/settings.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Other features</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editserviceoffered"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/pay1.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Service offered</h4>
                        </NavLink>
                      </div>
                    </div>
                  </Collapse>
                  <ReusableMenuLinkCollapse
                    onClick={this.openHealthAndSanitization}
                    state={this.state.openHealthAndSanitization}
                    srcImage={require('../../../assets/images/RightNavigationIcon/hand-sanitizer.svg')}
                    headingText="Health & Sanitization"
                  />
                  <Collapse in={this.state.openHealthAndSanitization}>
                    <div id="example-collapse-text">
                      <div className="example-collapse-text-inside">
                        <NavLink
                          exact
                          to="/edithealthandsenitation"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/doorway.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Entrance</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/edithealthandsenitationFacility"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/inside.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Inside Restaurant</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/edithealthandsenitationemployees"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/team.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Employees</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/edithealthandsenitationfoodhandling"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/Page.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Food Preparation</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/edithealthandsenitationSafety"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/verified.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Food Safety</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/edithealthandsenitationprotocol"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/description.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Description Protocol</h4>
                        </NavLink>
                      </div>
                    </div>
                  </Collapse>
                  <ReusableMenuLinkCollapse
                    onClick={this.openFoodCategories}
                    state={this.state.openFoodCategories}
                    srcImage={require('../../../assets/images/RightNavigationIcon/chef-hat.svg')}
                    headingText="Cuisine Setup"
                  />
                  <Collapse in={this.state.openFoodCategories}>
                    <div id="example-collapse-text">
                      <div className="example-collapse-text-inside">
                        <NavLink
                          exact
                          to="/editcategoryliquortype"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/Page-1.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Food Category & Liquor Information</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editfoodtype"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/spoon-and-fork.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Food Type</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editcuisineoffered"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/cocktail.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Cuisine Offered</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/editpointofsale"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/rounded-screen.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Point of Sale System</h4>
                        </NavLink>
                      </div>
                    </div>
                  </Collapse>
                  <ReusableMenuLink
                    onClick={(e) =>
                      this.props.history.push('/editbusinesshours')
                    }
                    srcImage={require('../../../assets/images/RightNavigationIcon/clock.svg')}
                    headingText="Business Timings"
                    styleClass={
                      this.props.history.location.pathname ===
                      '/editbusinesshours'
                        ? 'border border-dark'
                        : ''
                    }
                  />
                  <ReusableMenuLink
                    onClick={(e) => this.props.history.push('/editbankdetails')}
                    srcImage={require('../../../assets/images/RightNavigationIcon/clock.svg')}
                    headingText="KYC and License Info"
                    styleClass={
                      this.props.history.location.pathname ===
                      '/editbankdetails'
                        ? 'border border-dark'
                        : ''
                    }
                  />

                  <ReusableMenuLinkCollapse
                    onClick={this.openSubscriptions}
                    state={this.state.openSubscriptions}
                    srcImage={require('../../../assets/images/RightNavigationIcon/subscription.svg')}
                    headingText="Subscription"
                  />
                  <Collapse in={this.state.openSubscriptions}>
                    <div id="example-collapse-text">
                      <div className="example-collapse-text-inside">
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/waiting-room.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Listing Service</h4>
                        </NavLink>
                        {offerManagmentDisplay ? (
                          <NavLink
                            exact
                            to={
                              offerManagmentDisplay
                                ? '/edit-offers-subscription'
                                : '/profile'
                            }
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/tag.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Offers Management</h4>
                          </NavLink>
                        ) : null}
                        <NavLink
                          exact
                          to={'/editscan-pay-subscription'}
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/qr.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Scan & Pay</h4>
                        </NavLink>
                        {eventManagmentDisplay ? (
                          <NavLink
                            exact
                            to="/edit-event-subscription"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/event.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Events Management</h4>
                          </NavLink>
                        ) : null}

                        {/* {experienceManagmentDisplay ? ( */}
                        <NavLink
                          exact
                          to={
                            this.props?.multiDiningService
                              ? `/multi-service/experience-management`
                              : '/casual-fine-dining/experience-management'
                          }
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require('../../../assets/images/RightNavigationIcon/event.svg')}
                            alt="Dashboard Icon"
                          />
                          <h4>Experience Management</h4>
                        </NavLink>
                        {/* ) : null} */}
                        {liveStreamingDisplay ? (
                          <NavLink
                            exact
                            to={'/edit-live-streaming'}
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/live-streaming.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Live Streaming</h4>
                          </NavLink>
                        ) : null}
                        {seatingManagementDisplay ? (
                          <NavLink
                            exact
                            to="/edit-seating-subscription"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/waiting-room.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Seating</h4>
                          </NavLink>
                        ) : null}
                        {seatingManagementDisplay ? (
                          <NavLink
                            exact
                            to="/editgenralsettings"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/waiting-room.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>General Seating</h4>
                          </NavLink>
                        ) : null}
                        {seatingManagementDisplay ? (
                          <NavLink
                            exact
                            to="/editwalkinwaitlistsettings"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/subscription.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Walk-In/Wait List</h4>
                          </NavLink>
                        ) : null}
                        {seatingManagementDisplay ? (
                          <NavLink
                            exact
                            to="/editreservationsettings"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/Calendar.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Reservations</h4>
                          </NavLink>
                        ) : null}
                        {seatingManagementDisplay ? (
                          <NavLink
                            exact
                            to="/edit-table-management"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/Calendar.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Table Management</h4>
                          </NavLink>
                        ) : null}
                        {orderingManagementDisplay ? (
                          <NavLink
                            exact
                            to={
                              orderingManagementDisplay
                                ? '/edit-ordering-subscription'
                                : '/profile'
                            }
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/ordering.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Ordering</h4>
                          </NavLink>
                        ) : null}
                        {orderingManagementDisplay ? (
                          <NavLink
                            exact
                            to="/menusetup-dashboard"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require('../../../assets/images/RightNavigationIcon/buffet.svg')}
                              alt="Dashboard Icon"
                            />
                            <h4>Menu setup</h4>
                          </NavLink>
                        ) : null}
                      </div>
                    </div>
                  </Collapse>

                  <ReusableMenuLink
                    onClick={() => this.props.history.push('/customerbusiness')}
                    srcImage={require('../../../assets/images/RightNavigationIcon/settings.svg')}
                    headingText="Other Settings"
                  />

                  <ReusableMenuLink
                    onClick={this.onLogoutClick}
                    srcImage={require('../../../assets/images/RightNavigationIcon/logout.svg')}
                    headingText="Logout"
                  />

                  <div className="profile-and-close-css mt-2">
                    <div className="qr-code-bottom justify-content-center flex-column text-center">
                      <div className="text-dark f16-500 pb-3">Scan QR code</div>
                      <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                        style={{ width: 77, heght: 77 }}
                        value={JSON.stringify({
                          restaurant_id: this.state.onBoardingDataId,
                          type: 'door_front',
                          vendor_id: this.props?.onboarding?.vendor_id,
                        })}
                      />
                    </div>
                  </div>
                  <QRCodeMerchants
                    noAll
                    restaurantId={this.props.auth?.user?.VendorUser?._id}
                    restaurantLogo={this.state.restaurantLogo}
                    restaurantName={this.state.restaurantName}
                    door_front={{
                      restaurantId: this.props.onboarding?._id,
                    }}
                    notDisplay={true}
                  />
                  <div className="profile-and-close-css mt-2">
                    <div className="qr-code-bottom justify-content-center flex-column text-center">
                      <div
                        className="text-dark f16-500 pb-3"
                        // onClick={this.onOpenModal}
                      >
                        Referral QR code
                      </div>
                      <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                        style={{ width: 77, heght: 77 }}
                        value={
                          this.props.auth?.user?.VendorUser?.shareLink
                            ?.userShortLink || ' '
                        }
                      />
                    </div>
                  </div>
                  <QRCodeMerchants
                    noAll
                    restaurantId={this.props.auth?.user?.VendorUser?._id}
                    referral_data={
                      this.props.auth?.user?.VendorUser?.shareLink
                        ?.userShortLink || ''
                    }
                    notDisplay={true}
                    restaurantLogo={this.state.restaurantLogo}
                    restaurantName={this.state.restaurantName}
                  />
                  <div className="profile-and-close-css mt-2">
                    <div className="qr-code-bottom justify-content-center flex-column text-center">
                      <div
                        className="text-dark f16-500 pb-3"
                        // onClick={this.onOpenModal}
                      >
                        Webapp QR code
                      </div>
                      <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                        style={{ width: 77, heght: 77 }}
                        value={`${webappUrl}/restaurant/${this.props.onboarding?._id}`}
                      />
                    </div>
                  </div>
                  <QRCodeMerchants
                    noAll
                    webappUrl={`${webappUrl}/restaurant/${this.props.onboarding?._id}`}
                    notDisplay={true}
                    restaurantLogo={this.state.restaurantLogo}
                    restaurantName={this.state.restaurantName}
                  />
                  <div className="d-flex justify-content-center py-1">
                    <ShareLinkModal
                      userAppLink={
                        this.props.onboarding?.shareLink?.shortLink || ''
                      }
                      webAppLink={`${webappUrl}/restaurant/${this.props.onboarding?._id}`}
                    />
                  </div>
                  <div
                    style={{ textAlign: 'center' }}
                  >{`Version ${version}`}</div>
                </Scrollbars>
              </div>
            </Col>
          </div>
        </React.Fragment>
      );
    } catch (e) {
      console.log(e);
    }
  }
}

RightSideNavigation.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscriptionData:
    state.onboarding && state.onboarding.onboard_subscription_details,

  /********* Casual Dining service *********/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  casualDiningData:
    state?.onboarding?.onboard_subscription_details?.casual_dining_status,

  /********* Fast Food Dining service *********/
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  fastFoodDiningData:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining_status,

  /********* Multi Dining service *********/
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  multiDiningData:
    state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status,
  vendorAccess: state.vendorAccess,
});

export default connect(mapStateToProps, { clear_all_errors, logOutUser })(
  withRouter(RightSideNavigation)
);
